import React from 'react';
import { Tooltip, AsButton } from '@adserve/adserve-react-components';

const RequestCell = ({ data, onComponentClick, campaignProperties = [], readOnly = false }) => {
    const campaignProperty = campaignProperties?.find((c) => c.propertyId === data.id);

    return !campaignProperty || campaignProperty.outcome === 1 || campaignProperty.outcome === 2 ? (
        <Tooltip
            text={window.translate('Reservation Status')}
            marginTopAdjustment={10}
            marginLeftAdjustment={-4}
            style={{ width: 125 }}
        >
            <AsButton
                style={{
                    width: 75,
                    fontFamily: 'Roboto',
                    fontWeight: 500,
                    fontSize: 14,
                    height: 34
                }}
                useSecondaryStyle={!campaignProperty || campaignProperty.outcome === 2}
                handleClick={() => {
                    onComponentClick(data);
                }}
                disabled={readOnly}
            >
                {!campaignProperty || campaignProperty.outcome === 2
                    ? window.translate('Add')
                    : window.translate('Quote')}
            </AsButton>
        </Tooltip>
    ) : campaignProperty.outcome === 3 ? (
        <span>{window.translate('Reserved')}</span>
    ) : (
        <span>{window.translate('Awaiting approval')}</span>
    );
};

export default RequestCell;
